import compose from 'lodash/flowRight'
import {memo, Suspense} from 'react'
import {connect} from 'react-redux'

import {withUpdateResults} from '../../../contexts/update'
import type {State} from '../../../reducers/types'
import {getBuild, getBuildType, getIsStopping} from '../../../selectors'

import StopBuild from './StopBuild'
import {refreshBuildAfterStopping} from './StopBuild.actions'
import {getIsInterrupted} from './StopBuild.selectors'
import type {ActionProps, OwnProps, Props, StateProps} from './StopBuild.types'

const mapStateToProps = (state: State, {buildId, withAgent}: OwnProps): StateProps => {
  const {buildType, state: buildState, canceledInfo, agent} = getBuild(state, buildId) || {}
  const {projectId} = getBuildType(state, buildType) || {}
  return {
    projectId,
    agentName: withAgent === true ? agent?.name : null,
    state: buildState,
    isInterrupted: getIsInterrupted(state, buildId),
    isStopping: getIsStopping(state, buildId),
    stoppedWithComment: canceledInfo?.text,
    stoppedBy: canceledInfo?.user,
  }
}

const actionCreators: ActionProps = {
  onStop: refreshBuildAfterStopping,
}
export default compose(
  connect(mapStateToProps, actionCreators),
  memo,
  withUpdateResults(),
)(function StopBuildContainer(props: Props) {
  return (
    <Suspense>
      <StopBuild {...props} />
    </Suspense>
  )
})
